import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import LambdaUtil from '../../aws/lambda/lambdaUtil';
import TripSharingModal from './tripSharingModal';
import { strings } from '../../../localization';

export default class ShareTripButton extends PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            tripShareModalOpen: false,
        }
    }

    openTripShareModal = () => {

        this.setState({
            tripShareModalOpen: true,
        });

        document.documentElement.classList.add("no-scroll");

        this.onShareTrip();
    }

    closeTripShareModal = () => {

        this.setState({
            tripShareModalOpen: false,
        });

        document.documentElement.classList.remove("no-scroll");
    }

    onShareTrip = () => {

        this.setState({
            modalLoading: true,
        });

        LambdaUtil.getTripShareUrl(this.props.stage, this.props.ravenUuid, null, this.onTripShareSuccess, this.onTripShareError);
    }

    onTripShareSuccess = (response) => {

        console.log(response);
        try {
            var payload = JSON.parse(response.Payload);
            if (!payload || payload.status === "ERROR") {
                console.error(response);
                this.setState({
                    modalLoading: false,
                    errorMessage: strings.formatString(strings.ts_send_error)
                });
            } else {
                this.setState({
                    tripShareUrl: payload.tripUrl,
                    modalLoading: false
                });
            }
        } catch (e) {
            console.error('Unable to set trip share url', e);
            this.setState({
                modalLoading: false,
            });
        }
    }

    onTripShareError = (response) => {

        console.log(response);

        this.setState({
            modalLoading: false,
            errorMessage: strings.formatString(strings.ts_send_error)
        });
    }

    render() {

        return (
            <>
            <button onClick={this.openTripShareModal} className="btn btn-outline-blue btn-sm" title={strings.formatString(strings.share_trip_action)}>
                <i className="material-icons">gps_fixed</i> {strings.formatString(strings.btn_share_trip)}
            </button>
            <Modal
                className="react-modal-content react-modal-sm"
                isOpen={this.state.tripShareModalOpen}
                contentLabel="trip-sharing-modal"
                overlayClassName="react-modal-overlay"
                shouldCloseOnOverlayClick={true}
                ariaHideApp={false}
                onRequestClose={this.closeTripShareModal}>

                <TripSharingModal
                    modalLoading={this.state.modalLoading}
                    tripShareUrl={this.state.tripShareUrl}
                    closeTripShareModal={this.closeTripShareModal}
                    errorMessage={this.state.errorMessage} />
            </Modal>
            </>
        );
    }
}

ShareTripButton.propTypes = {
    stage: PropTypes.string.isRequired,
    ravenUuid: PropTypes.string.isRequired,
};
